<template>
    <div class="container-fluid h-100">
      <div class="container">
        <div class="mt-5 pt-4 row justify-content-center">
          <div class="col-12 mb-3">
            <label style="color: #616161;"><strong>EDITAR HAVOBLOG</strong></label><br>
          </div>
  
          <div class="col-12 m-0 p-0">
            <div class="form-group">
              <div class="row" style="text-align: left">
                <div style="margin:auto;" class="col-10">
                  <div style="min-width:100%;" class="col-10">
                    <div class="col-10">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>Nombre del blog * (el nombre no se interpretará como título)</strong>
                        </label>
                        <input
                          :class="{ 'is-danger': errors.name }"
                          type="text"
                          v-model="form.name"
                          class="form-control"
                          placeholder="Escribe aquí el nombre del blog"
                        />
                      </div>
                      <span
                        v-if="errors.name"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.name }}</span
                      >
                    </div>
                    <br>
                    <div class="col-10">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>Título blog *</strong>
                        </label>
                        <input
                          :class="{ 'is-danger': errors.title }"
                          type="text"
                          v-model="form.title"
                          class="form-control"
                          placeholder="Escribe aquí el título del blog"
                        />
                      </div>
                      <span
                        v-if="errors.title"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.title }}</span
                      >
                    </div>
                    <br>
                    <div class="col-10">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>SubTitulo blog *</strong>
                        </label>
                        <input
                          :class="{ 'is-danger': errors.subTitle }"
                          type="text"
                          v-model="form.subTitle"
                          class="form-control"
                          placeholder="Escribe aquí subtitulo del blog"
                        />
                      </div>
                      <span
                        v-if="errors.subTitle"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.subTitle }}</span
                      >
                    </div>
                    <br>
                    <div class="col-10">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="description"
                          style="color:#616161; font-size:14px;"
                        >
                          <strong>Texto del blog *</strong>
                        </label>
                        <div
                          ref="contentEditable"
                          contenteditable="true"
                          v-html="form.description"
                          @input="updateContent"
                          class="form-control content_blog"
                          placeholder="Escribe aquí el texto del blog"
                        ></div>
                      </div>
                      <span v-if="errors.description" class="text-danger float-left small error-danger mb-2">
                        {{ errors.description }}
                      </span>
                    </div>
                    <br>
                    <div class="col-4">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>Estado del blog * </strong>
                        </label>
                        <select
                          :class="{ 'is-danger': errors.status }"
                          class="form-control"
                          name="state"
                          id="state"
                          v-model="form.status"
                        >
                          <option value="null" disabled selected
                          >Seleccione el estado del blog
                          </option>
                          <option value="1">Activo</option>
                          <option value="2">Inactivo</option>
                        </select>
                      </div>
                      <span
                        v-if="errors.status"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.status }}</span
                      >
                    </div>
                    <br>
                    <div class="col-4">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>¿Permitir comentarios? *</strong>
                        </label>
                        <select
                          :class="{ 'is-danger': errors.comment }"
                          class="form-control"
                          name="state"
                          id="state"
                          v-model="form.comment"
                        >
                          <option value="null" disabled selected
                          >Seleccione una opción
                          </option>
                          <option value="1">Sí</option>
                          <option value="2">No</option>
                        </select>
                      </div>
                      <span
                        v-if="errors.comment"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.comment }}</span
                      >
                    </div>
                    <br><br>

                    <!-- Subir nueva imagen principal del blog -->
                    <div class="col-12">
                      <form ref="form" style="text-align:initial">
                        <label for="image" style="color:#616161; font-size:14px; text-align:initial;"
                        ><strong>Subir imagen principal del blog *</strong></label
                        ><br />
                        <input
                          type="file"
                          accept="image/*"
                          id="image"
                          name="image"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="selectImgMain($event)"
                          :class="{ 'is-danger': errors.imageMain }"
                          ref="imageInput"
                        />
                        <span v-if="errors.imageMain" class="text-danger small error-danger">{{
                          errors.imageMain
                        }}</span>
                        <br>
                      </form>
                      <div class="commentary">
                        <span>
                          RECOMENDACIÓN: solo se permiten imagenes en formato (jpg,jpeg,png).
                        </span><br>
                        <span>
                          El tamaño máximo debe ser de 1MB.
                        </span><br>
                        <span>
                          Para la imagen principal del blog el tamaño de la imagen debe ser de
                          1920 x 530 pixeles.
                        </span>
                      </div>
                    </div>
                    <!-- Imagen principal del blog -->
                    <div>
                      <img
                        id="preview-main"
                        style="max-width:200px; padding-left:15px;" 
                        v-if="main"
                        :src="main"
                        alt="Imagen blog"
                      />
                    </div><br>

                    <div class="col-12">
                      <form ref="form" style="text-align:initial">
                        <label for="image" style="color:#616161; font-size:14px; text-align:initial;"
                        ><strong>Subir resto de imágenes *</strong></label
                        ><br />
                        <input
                          type="file"
                          multiple
                          accept="image/*"
                          id="image"
                          name="image"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="imgSelected($event)"
                          :class="{ 'is-danger': errors.image }"
                          ref="imageInput"
                        />
                        <span v-if="errors.image" class="text-danger small error-danger">{{
                          errors.image
                        }}</span>
                        <br>
                      </form>
                      <div class="commentary">
                        <span>
                          RECOMENDACIÓN: solo se permiten imagenes en formato (jpg,jpeg,png).
                        </span><br>
                        <span>
                          El tamaño máximo debe ser de 1MB.
                        </span><br>
                        <span>
                          Para el resto de imágenes del blog el tamaño debe ser de
                          768 x 530 pixeles.
                        </span>
                      </div>
                    </div>

                    <!-- Listado de imágenes -->
                    <div id="imgSelect" class="col-12">
                      <template v-for="(img, i) in listImgs">
                        <div class="img-container form-check form-check-inline mt-3">
                          <label class="radio-inline">
                            <img
                              :src="img.url"
                              width="150"
                              :class="`img-h-${i}`"
                              class="mr-3"
                              alt="Imágenes blog"
                            />
                            <span class="delete-icon" @click="eliminarImagen(i)">X</span>
                          </label>
                        </div>
                      </template>
                    </div>

                    <div class="col-4">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>¿Que tipo de video desea adjuntar? *</strong>
                        </label>
                        <select
                          :class="{ 'is-danger': errors.type_video }"
                          class="form-control"
                          name="state"
                          id="state"
                          v-model="form.type_video"
                        >
                          <option value="null" disabled selected
                          >Seleccione una opción
                          </option>
                          <option value="1">Subir video</option>
                          <option value="2">Enlace de YouTube</option>
                        </select>
                      </div>
                      <span
                        v-if="errors.type_video"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.type_video }}</span
                      >
                    </div>

                    <div v-if="form.type_video == 1" class="col-12">
                      <form ref="form" style="text-align:initial">
                        <label for="image" style="color:#616161; font-size:14px; text-align:initial;"
                        ><strong>Subir vídeo</strong></label
                        ><br />
                        <input
                          type="file"
                          accept="video/*"
                          id="video"
                          name="video"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="videoSelected($event)"
                          :class="{ 'is-danger': errors.video }"
                          ref="videoInput"
                        />
                        <span v-if="errors.video" class="text-danger small error-danger">{{
                          errors.video
                        }}</span>
                        <br>
                      </form>
                      <div class="commentary">
                        <span>
                          RECOMENDACIÓN: solo se permiten vídeos en formato
                          (mp4).
                        </span>
                        <span>El tamaño máximo debe ser de 25MB.</span><br>
                        <span>
                          Las dimensiones del vídeo deben ser de 1920 x 530 pixeles.
                        </span>
                      </div>
                    </div>
                    
                    <!-- Previsualizar video -->
                    <div v-if="form.type_video == 1 && form.video != null" class="col-10">
                      <video style="width: 350px;" id="preview-video" controls></video>
                    </div>

                    <div v-if="form.type_video == 2" class="col-10">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                        ><strong>Enlace de YouTube</strong>
                        </label>
                        <input
                          :class="{ 'is-danger': errors.youtube_link }"
                          type="text"
                          v-model="form.youtube_link"
                          class="form-control"
                          placeholder="Pega aquí el enlace de YouTube"
                        />
                      </div>
                      <span
                        v-if="errors.youtube_link"
                        class="text-danger float-left small error-danger mb-2"
                      >{{ errors.youtube_link }}</span
                      >
                    </div>

                    <div class="col-12 mt-3 mb-3" style="text-align:center">
                      <button
                        @click="back()"
                        type="button"
                        class="btn btn-danger btn-sm button-login mr-3"
                      >
                        Regresar
                      </button>
                      <button
                        @click="updateBlog()"
                        type="button"
                        class="btn btn-danger btn-sm button-login"
                      >
                        <template v-if="loading.changeDoc">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                            Actualizando...
                        </template>
                        <template v-else>Actualizar blog</template>
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hr-border"></div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import $ from "jquery";
  import axios from 'axios'
  
  export default {
    data() {
      return {
        image: null,
        imageUrl: null,
        listImgs: [],
        main: null,
        blog: [],
        form: {
          name: null,
          title: null,
          subTitle: null,
          description: null,
          status: null,
          comment: null,
          type_video: 0,
          video: null,
          youtube_link: null,
        },
        errors: {
          name: false,
          title: false,
          subTitle: false,
          description: false,
          status: false,
          imageMain: false,
          image: false,
          comment: false,
          type_video: false,
          video: false,
          youtube_link: false,
        },
        loading: {
          changeDoc: false,
        },
        blogId: null,
      };
    },
    computed: {
      formattedDescription() {
        return this.form.description ? this.form.description.replace(/\n/g, "<br/>") : "";
      },
    },
    methods: {
      updateContent() {
        this.form.description = this.$refs.contentEditable.innerHTML;
      },
      back(){
        this.$router.push({ name: "listHavoblog" });
      },
      clear(){
        this.image = null;
        this.imageUrl = null;
        this.listImgs = [];
        const input = this.$refs.imageInput;
        if (input) {
          input.value = "";
        }
        this.form.name = null;
        this.form.title = "";
        this.form.subTitle = null;
        this.form.description = null;
        this.form.status = null;
        this.form.comment = null;
        this.form.type_video = 0;
        this.form.video = null;
        this.form.youtube_link = null;
        setTimeout(() => {
          this.errors.name = false;
          this.errors.title = false;
          this.errors.subTitle = false;
          this.errors.description = false;
          this.errors.status = false;
          this.errors.imageMain = false;
          this.errors.image = false;
          this.errors.comment = false;
          this.errors.type_video = false;
          this.errors.video = false;
          this.errors.youtube_link = false;
        },0);
      },
      selectImgMain(event) {
        var app = this;
        var fileSize = null;
        var extension = null;

        fileSize = event.target.files[0].size;
        extension = event.target.files[0].name.split(".");
        if (fileSize > 1000000) {
          app.errors.imageMain = "El archivo no debe superar 1MB.";
          return false;
        }
        if (
          extension[1] != "jpg" &&
          extension[1] != "png" &&
          extension[1] != "jpeg"
        ) {
          app.errors.imageMain = "La extensión es inválida.";
          return false;
        } else {
          app.errors.imageMain = false;
          app.main = event.target.files[0];
          // console.log('app.main 1 ', app.main);

          let imgMain = document.getElementById("preview-main");
          let reader = new FileReader();
          reader.readAsDataURL(app.main);
          reader.addEventListener('load', function(){
            imgMain.src = reader.result;
          });
        }
        app.main = event.target.files[0];
        // console.log('app.main 2 ', app.main);
      },
      imgSelected(event) {
        let app = this;
        var fileSize = null;
        var extension = null;
        if (this.listImgs.length + event.target.files.length > 4) {
          this.errors.image = "No se pueden adjuntar más de 4 imágenes.";
          return false;
        }
        // else if(this.listImgs.length + event.target.files.length < 2){
        //   this.errors.image = "No se pueden adjuntar menos de 2 imágenes.";
        //   return false;
        // }
        for (let i = 0; i < event.target.files.length; i++) {
          fileSize = event.target.files[i].size;
          extension = event.target.files[i].name.split(".");
          if (fileSize > 1000000) {
            this.errors.image = "El archivo no debe superar 1MB.";
            return false;
          }
          if (
            extension[1] != "jpg" &&
            extension[1] != "png" &&
            extension[1] != "jpeg"
          ) {
            this.errors.image = "La extensión es inválida.";
            return false;
          } else {
            this.errors.image = false;
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[i]);
            reader.onload = function(e) {
              const url = e.target.result;
              app.listImgs.push({ file: event.target.files[i], index: i, url });
            };
          }
        }
      },
      eliminarImagen(index) {
        this.listImgs.splice(index, 1);
      },
      videoSelected(event){
        let app = this;
        var fileSize = null;
        var extension = null;
        if (event.target.files.length > 1) {
          app.errors.video = "No se puede adjuntar más de 1 video.";
          return false;
        }
        for (let i = 0; i < event.target.files.length; i++) {
          fileSize = event.target.files[i].size;
          extension = event.target.files[i].name.split(".");
          if (fileSize > 25000000) {
            app.errors.video = "El archivo no debe superar 25MB.";
            return false;
          }
          if (extension[1] != "mp4") {
            app.errors.video = "La extensión es inválida.";
            return false;
          } else {
            app.errors.video = false;
            app.form.video = event.target.files[0];

            let video = document.getElementById("preview-video");
            let reader = new FileReader();
            reader.readAsDataURL(app.form.video);
            reader.addEventListener('load', function(){
              video.src = reader.result;
            });
          }
        }
      },
      validform(){
        let app = this;
        if (!app.form.name) {
          app.errors.name = "El nombre del blog es requerido.";
          return false;
        }
        if (!app.form.title) {
          app.errors.title = "El título del blog es requerido.";
          return false;
        }
        if (!app.form.subTitle) {
          app.errors.subTitle = "El subtitulo del blog es requerido.";
          return false;
        }
        if (!app.form.description) {
          app.errors.description = "La descripción del blog es requerida.";
          return false;
        }
        if (!app.form.status) {
          app.errors.status = "El estado del blog es requerido.";
          return false;
        }
        if (!app.form.comment) {
          app.errors.comment = "Debe eligir si se permiten comentarios en este blog.";
          return false;
        }
        // Validar el listado de imágenes
        // if (app.listImgs.length == 0){
        //   app.errors.image = "La imagen es requerida";
        //   return false;
        // }
        // Validación video
        // if (!app.form.type_video) {
        //   app.errors.type_video = "Debe eligir el tipo de video.";
        //   return false;
        // }
        if (app.form.type_video == 1) {
          if (!app.form.video) {
            app.errors.video = "Debe eligir un video.";
            return false;
          }
        }
        else if (app.form.type_video == 2) {
          if (!app.form.youtube_link) {
            app.errors.youtube_link = "Debe ingresar un enlace a un video de YouTube.";
            return false;
          }
        }
        if (
          !app.errors.name &&
          !app.errors.title &&
          !app.errors.subTitle &&
          !app.errors.description &&
          !app.errors.status &&
          !app.errors.comment &&
          !app.errors.image &&
          // !app.errors.type_video &&
          !app.errors.video &&
          !app.errors.youtube_link
        ) {
          return true;
        }
        return false;
      },
      updateImgMain(){

      },
      updateBlog(){
        if (this.validform()) {
          this.saveBlogUpdate();
        }
      },
      saveBlogUpdate(){
        const formData = new FormData();
        formData.append("id", this.blogId);
        formData.append("name", this.form.name);
        formData.append("title", this.form.title);
        formData.append("subTitle", this.form.subTitle);
        formData.append("description", this.form.description);
        formData.append("status_id", this.form.status);
        formData.append("comment_id", this.form.comment);
        formData.append("type_video", this.form.type_video);
        formData.append("youtube_link", this.form.youtube_link);
        formData.append("image", this.main);

        this.loading.changeDoc = true;
        axios
        .post("havoblog/updateBlog/" + this.blogId, formData)
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.cod == 0){
            if(res.data.data.type_video == 1){
              this.updateVideoBlog(res.data.data.id);
            }
            else if(this.listImgs.length > 1){
              this.updateImgsBlog(res.data.data.id);
            } else {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.loading.changeDoc = false;
              this.$router.push({ name: "listHavoblog" });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: "Ocurrió un error actualizando el blog",
          });
        });
      },
      updateVideoBlog(id) {
        const formData = new FormData();
        formData.append("video", this.form.video);
        formData.append("blogId", id);
        axios
        .post("havoblog/updateBlogVideo", formData)
        .then((res) => {
          if (res.data.cod == 0) {
            this.updateImgsBlog(id);
          } else {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.message,
            });
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
      },
      updateImgsBlog(id){
        console.log('entro a enviar imgs', JSON.stringify(this.listImgs));
        const formData = new FormData();
        var list = [];
        for (let i = 0; i < this.listImgs.length; i++) {
          if (this.listImgs[i].url.startsWith("https://")) {
            list.push(this.listImgs[i].url);
          } else {
            list.push(this.listImgs[i].file);
          }
        }
        for (let j = 0; j < list.length; j++) {
          formData.append("imgs[" + j + "]", list[j]);
        }
        formData.append("blogId", id);

        axios
        .post("havoblog/updateBlogImgs", formData)
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.loading.changeDoc = false;
            this.$router.push({ name: "listHavoblog" });
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.data.message,
          });
        });
      },
      getBlog(id){
        let app = this;
        axios
        .get("havoblog/infoBlog/" + id)
        .then((res) => {
          if(res.data.cod == 0){
            app.blog = res.data.data[0];
            // console.log('app.blog ', JSON.stringify(app.blog));
            // Se obtiene la información de los campos
            app.form.name = app.blog.name;
            app.form.title = app.blog.title;
            app.form.subTitle = app.blog.subtitle;
            app.form.description = app.blog.description;
            app.form.status = app.blog.status_id;
            app.form.comment = app.blog.comment;
            app.listImgs = app.blog.havoblog_post_files;
            app.main = app.blog.img;
            // Se agrega la imagen principal al array de imágenes
            // const imgObj = {
            //   url: app.blog.img,
            //   name: app.blog.img.split('/')[6],
            // };
            // app.listImgs.push(imgObj);
            app.form.type_video = app.blog.type_video;
            app.form.video = app.blog.video;
            app.form.youtube_link = app.blog.youtube_link;
          }
          else{
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.message
            });
          }
        })
        .catch((error) => {
          console.log('this is the error ', error);
        })
      },
    },
    mounted(){
      this.blogId = this.$route.params.blogId;
      this.getBlog(this.blogId);
    },
    watch: {
      "form.name": function(newV) {
        if (!newV) {
          this.errors.name = "El nombre del blog es requerido.";
        } else {
          this.errors.name = false;
        }
      },
      "form.title": function(newV) {
        if (!newV) {
          this.errors.title = "El nombre del producto es requerido.";
        } else {
          this.errors.title = false;
        }
      },
      "form.subTitle": function(newV) {
        if (!newV) {
          this.errors.subTitle = "El nombre del producto es requerido.";
        } else {
          this.errors.subTitle = false;
        }
      },
      "form.description": function(newV) {
        if (!newV) {
          this.errors.description = "La descripción del producto es requerida.";
        } else {
          this.errors.description = false;
        }
      },
      "form.status": function(newV) {
        if (!newV) {
          this.errors.status = "El estado del producto es requerido.";
        } else {
          this.errors.status = false;
        }
      },
      "form.comment": function(newV) {
        if (!newV) {
          this.errors.comment = "Debe eligir si se permiten comentarios en este blog.";
        } else {
          this.errors.comment = false;
        }
      },
      // "image": function(newV) {
      //   if (!newV) {
      //     this.errors.image = "La imagen es requerida.";
      //   } else {
      //     this.errors.image = false;
      //   }
      // },
      "form.type_video": function(newV) {
        if (!newV) {
          this.errors.type_video = "Debe eligir el tipo de video.";
        } else {
          this.errors.type_video = false;
        }
      },
      "form.video": function(newV) {
        if (!newV) {
          this.errors.video = "Debe eligir un video.";
        } else {
          this.errors.video = false;
        }
      },
      "form.youtube_link": function(newV) {
        if (!newV) {
          this.errors.youtube_link = "Debe ingresar un enlace a un video de YouTube.";
        } else {
          this.errors.youtube_link = false;
        }
      },
    },
  };
</script>
    
<style>
  .delete-icon {
    position: absolute;
    top: -15px;
    right: 15px;
    color: #dc3545;
    font-weight: bold;
    font-size: 1.5em;
    cursor: pointer;
    z-index: 1;
  }
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
  }
  .hr-border {
    border-top: 1px solid rgb(198 198 198);
    height: 15px;
    width: 100%;
    background-color: white;
  }
  .div-button {
   margin-top: 50px;
   text-align: left;
  }
  .is-danger {
    border: solid 2px !important;
    border-color: #e9434c !important;
  }
  .modal-title {
    color: black;
    font-weight: bold;
  }
  .modal-question {
    border: solid 3px;
    border-color: #dc3545;
    border-radius: 15px;
  }
  label {
   color: black;
   margin-right: 4px;
  }
  .img-banner {
    display: block;
    width: 25%;
    text-align: center;
    margin: auto;
  }
  td {
    text-align: center;
    vertical-align: -webkit-baseline-middle;
    cursor: all-scroll;
  }
  .table-container {
    overflow: auto;
  }
  h5 {
    margin-bottom: 10px !important;
  }
  .commentary {
    text-align: left;
    color: #1da5df;
    font-size: 13px;
  }
  .page-item.active .page-link {
    border-style: none;
    border-radius: 20px;
    background-color: #dc3545;
  }
  a.page-link {
    color: black;
    cursor: pointer;
  }
  a.page-link:hover {
    color: #dc3545;
  }
  .page-link {
    background-color: #f5f5dc00;
    border-radius: 20px;
    border-color: none;
  }
  .page-item.disabled .page-link {
    color: #dc3545;
    background-color: #fff0;
    border-color: #dee2e600;
  }
  .ul-pagination {
    padding: 0px;
  }
  .multiselect__tag {
    background-color: #dc3545 !important;
  }
  .multiselect__tag-icon:after {
    color: #ffffff;
    font-size: 18px;
  }
  .multiselect__tag-icon:hover {
    color: #ffffff;
    font-size: 18px;
    background-color: #b80012;
  }
  .multiselect__option--highlight {
    background: #17a2b8;
    outline: none;
    color: #fff;
  }
  .alert-danger {
    border-color: red !important;
  }
  .content_blog {
    border: 1px solid #ccc;
    padding: 10px;
    min-height: 300px;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: Arial, sans-serif;
    overflow-y: auto;
    unicode-bidi:bidi-override; 
    direction: ltr; 
  }
</style>